module.exports = __webpack_public_path__ + "img/SFC_nav.2fbf5b37.png";